_menuOpen = false;

_fixedElements = ['.header', '.btn-search', '#top-drawer .btn-close'];